import { FlightExchangeCheckoutComponent } from "../../pages/FlightsExchange/FlightExchangeCheckoutComponent";
import { Actions } from "./actions";
import { Guards } from "./guards";
import { getInitialFlightExchangeMachineContext } from "./initialContext";
import { Services } from "./services";
import { flightExchangeCheckoutMachine } from "./stateMachine";
import {
  populateCheckoutQueryParams,
  transitionStateOnPathnameChange,
  validateContext,
} from "./utilities";

const FLIGHT_EXCHANGE_CHECKOUT_TITLE = "Complete Flight Exchange";
const PORTAL_TITLE = "Hopper";

const initialContext = getInitialFlightExchangeMachineContext();

const onFlightExchangeCheckoutCleanUp = () => {
  document.title = PORTAL_TITLE;
};

const onFlightExchangeCheckoutLoad = () => {
  document.title = FLIGHT_EXCHANGE_CHECKOUT_TITLE;
};

export const flightExchangeCheckoutProps = {
  initialContext,
  validateContext,
  Component: FlightExchangeCheckoutComponent,
  actions: Actions,
  getInitialContext: getInitialFlightExchangeMachineContext,
  guards: Guards,
  onCleanUp: onFlightExchangeCheckoutCleanUp,
  onLoad: onFlightExchangeCheckoutLoad,
  onPathnameChange: transitionStateOnPathnameChange,
  onStateValueChange: populateCheckoutQueryParams,
  services: Services,
  stateMachine: flightExchangeCheckoutMachine,
};

export * from "./pages";
export * from "./types";
